import { makeStyles, createStyles } from '@material-ui/core/styles';

const EventEndedPageStyles = makeStyles((theme: any) =>
  createStyles({
    eventEndedMessageHolder: {
      display: "inline-block",
      width: 700,
      height: 200,
      textAlign: "center",
      position: "relative",
      backgroundColor: "black",
      top: 150,
    },
    eventEndedMessageHolderMobile: {
      width: "90%",
    },
    eventEndedMessage: {
      fontWeight: 400,
      fontSize: 16,
      color: "white",
      position: "relative",
      top: 85,
      right: 30,
    },
    endTimeErrorMessageMobile: {
      top: 75,
    },
  })
);

export { EventEndedPageStyles };